import { InjectionToken } from '@angular/core';

export const MAP_MARKER_DATA = new InjectionToken<any>('MAP_MARKER_DATA');
